import React, {
	Dispatch,
	SetStateAction,
	useCallback,
	useMemo,
	useState,
} from "react";
import { VelavuAsset, VelavuDevice, VelavuSite } from "velavu-js-api";
import { useToggleable } from "../../helper/hook-helper";
import { getLocationFloorID } from "../../helper/floor-helper";
import { serializeAssetCategorization } from "../../data/asset-categorization";
import { compoundSearchTags } from "../../helper/search-helper";

export interface FilterAnalyticsDevicesParams {
	categorization?: readonly string[];
	siteID?: string;
	floorID?: string;
	status?: boolean;
	searchQuery?: string;
}

export function filterAnalyticsDevices<T extends VelavuDevice>(
	devices: T[],
	params: FilterAnalyticsDevicesParams,
) {
	// Filter by site
	if (params.siteID !== undefined) {
		devices = devices.filter((asset) => asset.site_id === params.siteID);
		if (params.floorID !== undefined) {
			devices = devices.filter(
				(asset) =>
					getLocationFloorID(asset?.location) === params.floorID,
			);
		}
	}

	// Filter by status
	if (params.status !== undefined) {
		devices = devices.filter((asset) => asset.online === params.status);
	}

	// Filter by asset categorization
	const categorization = params.categorization;
	if (categorization !== undefined) {
		devices = devices.filter(
			(device) =>
				device.asset !== undefined &&
				categorization.includes(
					serializeAssetCategorization(device.asset),
				),
		);
	}

	// Filter by search
	if (params.searchQuery !== undefined) {
		devices = compoundSearchTags(devices, params.searchQuery);
	}

	return devices;
}
